// extracted by mini-css-extract-plugin
export default {"header":"ActiveManagement_header__F3fOV","total":"ActiveManagement_total__qGUHl"};